import type { FeedPage, Post } from '@sirocco/shared';
import { screenCacheKeys, seedScreenCache, updateScreenCache } from '../hooks/useAsync';

/**
 * Corriger un post partout ou il est deja affiche.
 *
 * Le fil ne se relit pas tout seul en revenant — c'est voulu, sans quoi
 * le post qu'on lisait glisserait sous ceux arrives entre-temps. Mais un
 * like pose sur le post ouvert restait alors dans cet ecran-la : on
 * revenait au fil, et le coeur y etait de nouveau vide. La base avait
 * bien enregistre le like ; c'est la page gardee en memoire qui datait
 * d'avant.
 *
 * On la corrige donc a la source, pour chaque liste qui porte ce post :
 * le fil et ses recherches, mes posts, mes signets. Une liste jamais
 * chargee est ignoree — elle ira chercher l'etat a jour d'elle-meme.
 */
export function propagerLePost(post: Post): void {
  // La fiche du post, pour l'ecran suivant qui l'ouvrira.
  seedScreenCache(`post:${post.id}`, post);

  const remplacer = (liste: Post[]) =>
    liste.map((autre) => (autre.id === post.id ? post : autre));

  for (const cle of screenCacheKeys('feed')) {
    updateScreenCache<FeedPage>(cle, (page) => ({ ...page, posts: remplacer(page.posts) }));
  }
  updateScreenCache<Post[]>('my-posts', remplacer);
  updateScreenCache<Post[]>('bookmarks:posts', remplacer);
}
